/**
 * @class Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService
 *
 * Handles WFS layers' states, for example selected features, top WFS layer, selected WFS layers etc.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService',
/**
 * @method create called automatically on construction
 * @static
 *
 * @param {Oskari.Sandbox} sandbox
 *          reference to application sandbox
 */

function (sandbox) {
  var me = this;
  me.sandbox = sandbox;
  me.selectedWFSLayers = [];
  me.selectedWFSLayerIds = [];
  me.selectFromAllLayers = false;
  me.selectionToolsActive = null;
  for (var p in me.eventHandlers) {
    if (me.eventHandlers.hasOwnProperty(p)) {
      me.sandbox.registerForEventByName(me, p);
    }
  }
}, {
  /** @static @property __qname fully qualified name for service */
  __qname: 'Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService',
  /**
   * @method getQName
   * @return {String} fully qualified name for service
   */
  getQName: function getQName() {
    return this.__qname;
  },
  /** @static @property __name service name */
  __name: 'WFSLayerService',
  /**
   * @method getName
   * @return {String} service name
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @public @method onEvent
   * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
   *
   * @param {Oskari.mapframework.event.Event} event a Oskari event object
   *
   */
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  /**
   * @static @property {Object} eventHandlers
   */
  eventHandlers: {
    AfterMapLayerAddEvent: function AfterMapLayerAddEvent(event) {
      var layer = event.getMapLayer();
      if (layer.hasFeatureData()) {
        this.setWFSLayerSelection(layer, true);
      }
    },
    AfterMapLayerRemoveEvent: function AfterMapLayerRemoveEvent(event) {
      var layer = event.getMapLayer();
      if (layer.hasFeatureData()) {
        this.setWFSLayerSelection(layer, false);
      }
    }
  },
  /**
   * @method setWFSLayerSelection
   * @param {Object} WFS layer; WFS Layer which is selected or unselected
   * @param {Boolean} add; true if WFS layer is selected and false if WFS layer is removed from selections
   *
   * Handles the state of selected WFS layers
   */
  setWFSLayerSelection: function setWFSLayerSelection(layer, add) {
    var selectedLayers = this.getSelectedWFSLayerIds();
    var layerId = layer.getId();
    if (add) {
      selectedLayers.push(layerId);
    } else {
      selectedLayers = selectedLayers.filter(function (id) {
        return id !== layerId;
      });
    }
    // update selected layers
    this.selectedWFSLayerIds = selectedLayers;
  },
  /**
   * @method getSelectedWFSLayerIds
   *
   * @return {Array} this.selectedWFSLayerIds; Ids of selected WFS layers
   */
  getSelectedWFSLayerIds: function getSelectedWFSLayerIds() {
    return this.selectedWFSLayerIds;
  },
  /**
   * @method getTopWFSLayer
   *
   * @return {Number} me.topWFSLayer; Id of the top WFS layer
   */
  getTopWFSLayer: function getTopWFSLayer() {
    var me = this,
      layers = me.sandbox.findAllSelectedMapLayers(),
      topWFSLayer;
    for (var i = 0; i < layers.length; i++) {
      var layer = layers[i];
      if (layer.hasFeatureData()) {
        topWFSLayer = layer._id;
      }
    }
    return topWFSLayer;
  }
});